import { useAuthHeader, useAuthUser } from "react-auth-kit";
import { useMutation, useQuery, useQueryClient } from "react-query";
import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { doctorValues, userValues } from ".";
import { useGetDoctorById } from "../DoctorComponents";
import { toastError, toastSuccess } from "../../utils/utils";

export const useChangePassword = () => {
  const authHeader = useAuthHeader();

  return useMutation({
    mutationFn: async (updatedObject) => {
      const res = await axiosInstance.put(
        "/users/change_password",
        updatedObject,
        {
          headers: {
            Authorization: authHeader(),
          },
        }
      );
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      toast.success("La tua password è stata cambiata!", toastSuccess);
    },
    onError: (data, variables, context) => {
      toast.error("Errore nell'aggiornamento della password", toastError);
    },
  });
};

export const useUpdateUser = (user_id) => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  const getOriginalData = useGetUserById(user_id);

  return useMutation({
    mutationFn: async (newUser) => {},
  });
};

export const useUpdateCurrentUser = () => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  const getOriginalData = useGetCurrentUser();

  return useMutation({
    mutationFn: async (updatedUser) => {
      const res = await axiosInstance.put("/users/current", updatedUser, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    onSuccess: () => {
      toast.success("Dettagli utente aggiornati!", toastSuccess);
    },
    onError: () => {
      toast.error("Dettagli utente non aggiornati", toastError);
    },
  });
};

export const useUpdateCurrentDoctor = () => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  const authUser = useAuthUser();

  return useMutation({
    mutationFn: async (updatedUser) => {
      delete updatedUser.profile;
      const res = await axiosInstance.put("/doctors/current", updatedUser, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    onSuccess: () => {
      toast.success("Dettagli professionista aggiornati!", toastSuccess);
    },
    onError: () => {
      toast.error("Dettagli professionista non aggiornati", toastError);
    },
  });
};

export const useGetUserById = (user_id) => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["users", user_id],
    queryFn: async () => {
      const res = await axiosInstance.get(`/users/${user_id}`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    enabled: user_id !== undefined && user_id !== null,
  });
};
export const useGetCurrentUser = () => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["users", "current"],
    queryFn: async () => {
      const res = await axiosInstance.get(`/users/current`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
  });
};

export const useGetCurrentDoctor = () => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["doctors", "current"],
    queryFn: async () => {
      const res = await axiosInstance.get(`/doctors/current`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
  });
};
